import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class CustomValidators {

  static fieldsMatch(fields: string[]): ValidatorFn {
    return (group: UntypedFormGroup): ValidationErrors | null => {
      let error = null;
      const check: Set<string> = new Set<string>();
      fields.forEach((fieldName: string) => {
        const control: AbstractControl = group.controls[fieldName];
        if (!control) {
          throw new Error(`The specified field ${fieldName} doesn't belong to the FormGroup!`);
        }
          check.add(control.value);
      }); 
    
      if ([...check].filter(val => !!val).length > 1) {
        error = { fieldsDontMatch: true };
      }

      return error;
    }; 
  }
}
